export const handleResponse = response => {
  const contentType = response.headers.get("content-type");
  if (response.status === 204) return;
  if (contentType && contentType.indexOf("application/json") !== -1) {
    if (response.ok) return response.json()
    return response.json()
      .then(json => {
        const error = new Error(json.message);
        error.code = json.code;
        error.url = response.url;
        error.statusCode = response.status;
        error.json = JSON.stringify(json)
        throw error;
      })
  } else {
    return response.text().then(text => {
      const error = new Error(response.statusText);
      error.url = response.url;
      error.statusCode = response.status;
      error.body = text;
      throw error;
    });
  }
}